import React, { useEffect } from "react";
import { StyledSelectOptions } from "../setup.style";
import SelectOptions from "./SelectOptions";
import { prepFBAccounts } from "../../../services/dataService";
import {getFBAccountsData} from "../../../services/globalService";

const SelectFBAccount = ({ setFBState, FBState }) => {
    useEffect(() => {
        let didCancel = false;
        const getData = async () => {
            try {
                if (!didCancel && !(sessionStorage.fbId && sessionStorage.fbToken)) {
                    if(process.env.NODE_ENV !== 'production') {
                        console.info("failed getting FB accounts from Fixel API");
                    }
                    return setFBState({
                        ...FBState,
                        connectionFailed: true,
                        showSelectAccount: false,
                        showConnectFB: true,
                    });
                }
                const response = await getFBAccountsData();
                if (!didCancel) {
                    if (response) {

                        setFBState({ ...FBState, fbAccountData: prepFBAccounts(JSON.parse(response?.data?.data)) });
                    } else {
                        if(process.env.NODE_ENV !== 'production') {
                            console.info("failed getting FB accounts from Fixel API");
                        }
                        setFBState({
                            ...FBState,
                            connectionFailed: true,
                            showSelectAccount: false,
                            showConnectFB: true,
                        });
                    }
                }
            } catch (error) {
                console.error(
                    "TCL ~ file: SelectFBAccount.js ~ getFbAccountData ~ error",
                    error.message || error,
                );
            }
        };
        getData();
        return () => {
            didCancel = true;
        };
    }, []);

    const validateAccountData = (account) => {
        if (account) return account.pixels && account.pixels.length;
    };

    return (
        <StyledSelectOptions>
            <SelectOptions
                label="Select Ad Account:"
                htmlFor="adAccount"
                isRequired={true}
                defaultValue="Please select an account"
                isError={!(FBState.fbAccountData && FBState.fbAccountData.length)}
                errorMsg="No ad accounts were found"
                options={FBState.fbAccountData}
                onChange={(e) => {
                    setFBState({ ...FBState, selectedAccountIndex: e.target.value, selectedPixelIndex: -1 });
                }}
                value={FBState.selectedAccountIndex}
                disabled={!(FBState.fbAccountData && FBState.fbAccountData.length)}
            />
            <SelectOptions
                label="Select Pixel:"
                htmlFor="pixel"
                isRequired={true}
                defaultValue="Please select a pixel"
                isError={!validateAccountData(FBState.fbAccountData[FBState.selectedAccountIndex])}
                errorMsg="Please select an account with pixels"
                options={
                    validateAccountData(FBState.fbAccountData[FBState.selectedAccountIndex])
                        ? FBState.fbAccountData[FBState.selectedAccountIndex].pixels
                        : []
                }
                onChange={(e) => {
                    setFBState({ ...FBState, selectedPixelIndex: e.target.value });
                }}
                value={FBState.selectedPixelIndex}
                disabled={!validateAccountData(FBState.fbAccountData[FBState.selectedAccountIndex])}
            />
        </StyledSelectOptions>
    );
};
export default SelectFBAccount;
